export class Tags {
  id: string;
  items: string[];
  schemaVersion: string;
  isDeleted: boolean;
  isValid: boolean;
  createdBy: string;
  createDate: string;
  lastUpdatedBy: string;
  lastUpdateDate: string;
}

export class TagsUpsert {
  items: string[];
  schemaVersion: string;
}
